<template>
<div class="container-box-entry">
	<div>
		<quick-actions-btn :items="[
				{label:`Set ${item.type==='%'?'fixed':'fluid'} width`},
				{label:'Delete box', icon:require('@/assets/img/trash.svg')}]"
		                   @menuClick="menuClick"/>
	</div>

	<div class="flex" style="width: 50px">
		#{{index+1}}
	</div>
	<div class="width">
		<span>W: </span>
		<input-field small flat type="number" :value="item.width"
		             @input="update($event)"
		             :min="0" :max="item.type==='%'?100:100000"
		             :placeholder="orientation==='row'?'auto':'100'" :append="item.type||'%'" :step="10" />
	</div>

	<a class="drag_action_with_lines">
		<i class="icon icon-burger"></i>
	</a>
</div>
</template>

<script>
import VButton from '@/components/base/v-button'
import InputField from '@/components/base/input-field'
import QuickActionsBtn from '@/components/base/quick-actions-btn'
import {getOrientation} from "@/modules/page-editor/src/utils/props";
import {mapGetters} from "vuex";

export default {
	name: "ContainerBoxEntry",
	components:{VButton,InputField,QuickActionsBtn},
	props:['index','item','content'],
	computed:{
		...mapGetters(['current_view']),
		orientation(){
			return getOrientation(this.content.attributes.basic.orientation, this.current_view);
		},
	},
	methods:{
		update(ev) {
			this.$set(this.item, "width", ev)
			this.$emit('updated', this.item)
			// this.item.width = ev;
		},
		menuClick({action}){
			if (action==="Delete box") {
				this.$emit('delete')
			} else if (action==="Set fixed width") {
				this.item.type = "px"
				this.$emit('updated', this.item);
			} else if (action==="Set fluid width") {
				this.item.type = "%"
				if (this.item.width > 100) this.item.width = 100;
				this.$emit('updated', this.item);
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.container-box-entry {
	border-radius: 5px;
	padding: 5px 10px;
	display: flex;
	flex-direction: row;
	flex: 1;
	width: 100%;
	align-items: center;

	.width {
		margin-right: 10px;
		min-width: 90px;
		max-width: 90px;
		display: flex;
		flex-direction: row;
		align-items: center;
		span {
			color: $grey;
		}
		.input-field {
			width: 100%;
		}
	}
&:hover {
	background: $light-silver;
}
}
</style>
